import React, { useEffect, useState } from "react";

export default function StockGame() {
    const [prices, setPrices] = useState({ A: 100, B: 100 });
    const [history, setHistory] = useState({ A: [100], B: [100] });

    const [holdings, setHoldings] = useState({ A: 0, B: 0 });

    // NEW: Track total cash instead of profit
    const [cash, setCash] = useState(0);

    // Price auto-update
    useEffect(() => {
        const interval = setInterval(() => {
            setPrices(prev => {
                const newA = Math.max(1, Math.round(prev.A + (Math.random() - 0.5) * 10));
                const newB = Math.max(1, Math.round(prev.B + (Math.random() - 0.5) * 10));

                setHistory(h => ({
                    A: [...h.A.slice(-49), newA],
                    B: [...h.B.slice(-49), newB]
                }));

                return { A: newA, B: newB };
            });
        }, 800);

        return () => clearInterval(interval);
    }, []);

    // Buy stock (unlimited, allows negative cash)
    function buy(stock) {
        setHoldings(h => ({
            ...h,
            [stock]: h[stock] + 1
        }));

        setCash(c => c - prices[stock]);
    }

    // Sell stock
    function sell(stock) {
        if (holdings[stock] > 0) {
            setHoldings(h => ({
                ...h,
                [stock]: h[stock] - 1
            }));

            setCash(c => c + prices[stock]);
        }
    }

    // Draw mini-line-chart
    const makeGraph = (historyArr) => {
        const width = 520;
        const height = 300;
        const min = Math.min(...historyArr);
        const max = Math.max(...historyArr);
        const range = max - min || 1;

        return (
            <svg width={width} height={height} style={{ background: "#ffe3f2", border: "2px solid #d63384" }}>
                {historyArr.map((p, i) => {
                    if (i === 0) return null;
                    const prev = historyArr[i - 1];

                    const x1 = (i - 1) * (width / 50);
                    const x2 = i * (width / 50);

                    const y1 = height - ((prev - min) / range) * height;
                    const y2 = height - ((p - min) / range) * height;

                    return (
                        <line key={i} x1={x1} y1={y1} x2={x2} y2={y2}
                              stroke="#d63384" strokeWidth="3" />
                    );
                })}
            </svg>
        );
    };

    return (
        <div style={{ textAlign: "center", padding: "20px" }}>
            <h2>Make Money Off the Stocks!</h2>
            <p>Buy low, sell high!</p>

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "40px",
                    marginTop: "30px"
                }}
            >
                {/* STOCK A */}
                <div style={{ width: "300px" }}>
                    <h3>Company A — ${prices.A}</h3>
                    {makeGraph(history.A)}

                    <button onClick={() => buy("A")} style={btnStyle}>
                        BUY A
                    </button>
                    <button
                        onClick={() => sell("A")}
                        disabled={holdings.A === 0}
                        style={btnStyle}
                    >
                        SELL A
                    </button>

                    <p>You own <strong>{holdings.A}</strong> A shares</p>
                </div>

                {/* STOCK B */}
                <div style={{ width: "300px" }}>
                    <h3>Company B — ${prices.B}</h3>
                    {makeGraph(history.B)}

                    <button onClick={() => buy("B")} style={btnStyle}>
                        BUY B
                    </button>
                    <button
                        onClick={() => sell("B")}
                        disabled={holdings.B === 0}
                        style={btnStyle}
                    >
                        SELL B
                    </button>

                    <p>You own <strong>{holdings.B}</strong> B shares</p>
                </div>
            </div>

            <hr style={{ margin: "30px auto", width: "60%" }} />

            {/* CASH READOUT */}
            <p style={{ fontSize: "26px" }}>
                Cash:{" "}
                <strong style={{ color: cash >= 0 ? "green" : "red" }}>
                    ${cash}
                </strong>
            </p>
        </div>
    );
}

const btnStyle = {
    margin: "5px",
    padding: "8px 14px",
    background: "#ff66a3",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer"
};
